import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const cardStatusService = {
  getCardStatus
};

function getCardStatus(params) {
  return apiCall("GET", apiUrls.status.card, null, params);
}
